<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.title' | translate"
    [nzActive]="true"
  >
    <nz-form-item>
      <nz-form-label
        class="quali-form-label"
        nzNoColon
        [nzRequired]="nameFormControl.hasValidator(Validators.required)"
      >
        {{ 'general.name' | translate }}
      </nz-form-label>
      <nz-form-control>
        <input
          nz-input
          type="text"
          [formControl]="nameFormControl"
          [placeholder]="'general.name' | translate"
        />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label
        class="quali-form-label"
        nzNoColon
        [nzRequired]="labelsFormControl.hasValidator(Validators.required)"
      >
        {{ 'page.training-qualifications.labels' | translate }}
      </nz-form-label>
      <nz-form-control>
        <wilson-select-labels
          [selectedLabels]="labelsFormControl.value ?? []"
          (changedLabels)="labelsFormControl.setValue($event)"
          [maxTagCount]="3"
          [enableNoLabelOption]="false"
        ></wilson-select-labels>
      </nz-form-control>
    </nz-form-item>
  </nz-collapse-panel>
</nz-collapse>
